<template>
  <div>
    <div id="main" style="width:100%">
    <div id="left" style="width:50%;float:left;">
  <el-form ref="currentModule" :model="currentModule">
    <el-row>
      <el-form-item>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>模块设置</el-breadcrumb-item>
        </el-breadcrumb>
      </el-form-item>
    </el-row>
    <el-row>
      <el-col :span="16">
        <el-form-item label="节点选择" :label-width="formLabelWidth">
          <el-input
              placeholder="请选择"
              v-model="moduleName"
              auto-complete="off"
          >
          </el-input>
          <el-tree
              :highlight-current = true
              :default-expand-all = false
              :expand-on-click-node="false"
              :data="navigationData"
              :props="defaultProps"
              :draggable="true"
              :allow-drop="allowDrop"
              node-key="moduleid"
              accordion
              @node-click="onSelectModuleNode"
              @node-drop="sort"
              class="module-navigatetree"
              ref="moduleTree"
              :filter-node-method="filterModuleNode"
              :default-expanded-keys="treeExpandData"
          >
            <template #default="scope">
                <span>
                    <i :class="scope.data.iconName"></i>{{ scope.data.name }}
                </span>
              <span v-if="test(scope.data.name)" >
                <i class="small-operation-btn el-icon-plus"  @click="onClickAddNode()"/>
                <i class="small-operation-btn el-icon-edit " @click="onClickMdfNode()"/>
                <i class="small-operation-btn el-icon-delete" @click=" onClickDelNode()"/>
              </span>
              <span class="custom-tree-btn">
                <i :class="scope.data.iconName"></i>
                </span>
            </template>
          </el-tree>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-button-group>
          <el-button type="primary" icon="el-icon-search" @click="onSearchModuleNode">搜索</el-button>
          <el-button type="primary" icon="el-icon-close" @click="onClearModuleName">清空</el-button>
        </el-button-group>
      </el-col>
    </el-row>
  </el-form>
  </div>
  </div>
    <div id="right" style="width:50% ;float:left">
    <el-row> </el-row>
    <el-row> </el-row>
    <el-row>
      <el-col :span="24">
        <el-form>
        <el-form-item label="当前页面" :label-width="formLabelWidth">
          <el-check-tag
              v-for="(page, index) in currentModule.pages"
              :key="page"
              :disable-transitions="false"
              :checked="currentModule.pageIndex==index"
              @change="onSwitchPage(index)"
          >
            {{ page.label }}
          </el-check-tag>
        </el-form-item>
        </el-form>
      </el-col>
    </el-row>
      <el-row>
        <el-col :span="24">
          <el-form>
          <el-form-item label="展示名称" :label-width="formLabelWidth">
            <el-input v-model="curNewPageName" @change="onChangePageName"></el-input>
          </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form>
          <el-form-item label="展示方式" :label-width="formLabelWidth" >
            <el-select
                v-model="currentModule.display" placeholder="展示方式" @change="onChangePageType">
              <el-option
                  v-for="(value, key) in display"
                  :key="key"
                  :label="value.label"
                  :value="key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    <el-row>
      <el-col :span="24">
      <el-form>
      <el-form-item label="页面操作" :label-width="formLabelWidth">
      <el-button-group>
        <el-button icon="el-icon-plus" class="button-new-tag" size="small" @click="onClickAddPage">添加页面</el-button>
        <el-button icon="el-icon-minus" class="button-new-tag" size="small" @click="onClickDelPage">删除页面</el-button>
      </el-button-group>
      </el-form-item>
      </el-form>
      </el-col>
    </el-row>
    <el-row >
      <el-col :span="16">
        <el-form>
        <el-form-item label="页面名称" :label-width="formLabelWidth">
          <el-input
              placeholder="请选择"
              v-model="pageName"
              auto-complete="off"
          >
            <template #prefix>
              <el-icon class="el-icon-arrow-down" @click="popPageTree">
                <edit />
              </el-icon>
            </template>
          </el-input>
          <div
              v-show="isPopPageTree"
              style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 102;"
              @click="unPopPageTree">
          </div>
          <el-tree
              v-show="isPopPageTree"
              :highlight-current = true
              :default-expand-all = false
              :expand-on-click-node="false"
              :data="allPages"
              :props="defaultProps"
              node-key="pageid"
              accordion
              @node-click="onSelectPage"
              class="module-pagetree"
              ref="pageTree"
              :filter-node-method="filterPageNode"
          >
            <template #default="scope">
                <span class="custom-tree-node">
                    {{ scope.data.label }}
                </span>
            </template>
          </el-tree>
        </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-button-group>
          <el-button type="primary" icon="el-icon-search" @click="onSearchPageNode">搜索</el-button>
          <el-button type="primary" icon="el-icon-close" @click="onClearPageName">清空</el-button>
        </el-button-group>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="24">
      <el-form>
    <el-form-item label="添加备注" :label-width="formLabelWidth">
      <el-input
          placeholder="请输入"
          v-model="remark"
          rows="16"
          type="textarea"
          class="remark"
          auto-complete="off"
      >
      </el-input>
    </el-form-item>
      </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item style="text-align: right">
          <el-button type="primary" icon="el-icon-check" @click="onClickOk()">提交</el-button>
        </el-form-item>
      </el-col>
    </el-row>

  </div>
  </div>
</template>

<script>
import axios from "axios";
import eventInsim from "@/event";
import {ElMessage, ElMessageBox} from "element-plus";
//兼容语法 async focus

export default {
  data() {
    return {
      formLabelWidth: '80px',
      navigationData: [],
      treeExpandData:[], //用于接收tree树id的数组
      provincialCenterId:[], //默认展开节点
      sortcache: {},
      isPopModuleTree: true,
      isPopPageTree: false,
      pageManager: false,
      ConButton:false,
      selPageSeq: 0,
      allPages: [],
      moduleName: "",
      pageName: "",
      pagelabel:"",
      remark:"",
      display:{
        "Horizontal":{
          label:"横向展示"
        },
        "Vertical": {
          label:"垂直展示"
        }
      },
      curNewPageName:"",//新命名的页面名称
      currentModule: {
        moduleid: "511029F7F507403FAB16414EEE68653D",
        name: "基础数据综合应用",
        seq: 1000000,
        idx: "1",
        pid: "root",
        lev: 1,
        isLeaf: false,
        pageIndex: -1,
        pages: [],
        remark:"",
        display:"Horizontal",
        addPage(page) {
          let that = this;
          if (page == null) {
            that.pages.push({
              label: '',
              pageid: '',
              route:'components/busView.vue',
              type:''
            });
          }
          else {
            that.pages.push(page);
          }
          that.pageIndex++;
        },
        delPage(index) {
          let that = this;
          if (index >= 0 && index < that.pages.length) {
            that.pages.splice(index, 1);
            that.pageIndex = index - 1;
          }
        },
        selectPage(index) {
          let that = this;
          that.pageIndex = index;
        },
        clearPages() {
          this.pages = [];
          this.pageIndex = -1;
        }
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  mounted: function () {
    let that = this;
    that.fetchNavigationData();
    that.fetchAllPage();
  },
  methods: {
    test: function(name) {
      let that = this;
      let result = false;
      if (name == that.moduleName) {
        result = true;
      }
      return result;
    },
    mouseenter(data){
      this.$set(data, 'show', true)
    },
    mouseleave(data){
      this.$set(data, 'show', false)
    },
    //获得默认展开节点
    getRoleTreeRootNode(provincialCenterId) {
      this.treeExpandData.push(provincialCenterId)
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        //aboveId:父节点id
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理
        return false;
      }
    },

    onChangePageType(type){
      let that = this;
      that.currentModule.display = type;
      console.log(type)
    },
    //拖拽排序
    sort(draggingNode, dropNode, type) {
      let that = this;
      let data = type != "inner" ? dropNode.parent.data : dropNode.data;
      let nodeData = dropNode.level == 1 && type != "inner" ? data : data.children;
      nodeData =Array.from(nodeData);
      nodeData.forEach(element =>{
        element.pid = data.id;
      });
      nodeData.forEach((element, i) => {
        // 向上拖动
        if(draggingNode.data.seq>dropNode.data.seq) {
          if(element.seq<=draggingNode.data.seq&&element.seq>=dropNode.data.seq) {
            let Seq = element.seq;
            Seq = Seq.toString();
            let M = element.lev;
            let temSeq="";
            if(i+1<10){
              temSeq = Seq.substring(0,2*(M-1)-1) + "0"+ ""+(i+1) + Seq.substring(2*(M-1)+1);
              element.seq = temSeq;
            }
            else {
              temSeq = Seq.substring(0,2*(M-1)-1) + ""+(i+1) + Seq.substring(2*(M-1)+1);
              element.seq = temSeq;
            }
            // 处理子节点
            if(element.isLeaf==false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j=0;j<len;j++) {
                leafSeq = element.children[j].seq
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if(i+1<10){
                  temleafSeq = leafSeq.substring(0,2*(M-1)-1) + "0"+ ""+(i+1) + leafSeq.substring(2*(M-1)+1);
                  element.children[j].seq = temleafSeq;
                }
                else {
                  temleafSeq = leafSeq.substring(0,2*(M-1)-1) + ""+(i+1) + leafSeq.substring(2*(M-1)+1);
                  element.children[j].seq = temleafSeq;
                }
                that.sortcache[element.children[j].moduleid]=temleafSeq;
              }

            }
            that.sortcache[element.moduleid]=temSeq;
          }
        }
        // 向下拖动
        else {
          if(element.seq>=draggingNode.data.seq&&element.seq<=dropNode.data.seq) {
            let Seq = element.seq;
            Seq = Seq.toString();
            let M = element.lev;
            let temSeq="";
            if(i+1<10){
              temSeq = Seq.substring(0,2*(M-1)-1) + "0"+ ""+(i+1) + Seq.substring(2*(M-1)+1);
              element.seq = temSeq;
            }
            else {
              temSeq = Seq.substring(0,2*(M-1)-1) + ""+(i+1) + Seq.substring(2*(M-1)+1);
              element.seq = temSeq;
            }
            // 处理子节点
            if(element.isLeaf==false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j=0;j<len;j++) {
                leafSeq = element.children[j].seq
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if(i+1<10){
                  temleafSeq = leafSeq.substring(0,2*(M-1)-1) + "0"+ ""+(i+1) + leafSeq.substring(2*(M-1)+1);
                  element.children[j].seq = temleafSeq;
                }
                else {
                  temleafSeq = leafSeq.substring(0,2*(M-1)-1) + ""+(i+1) + leafSeq.substring(2*(M-1)+1);
                  element.children[j].seq = temleafSeq;
                }
                that.sortcache[element.children[j].moduleid]=temleafSeq;
              }
            }

            that.sortcache[element.moduleid]=temSeq;
          }
        }
      });
      console.log(that.sortcache)

    },

    popModuleTree() {
      this.isPopModuleTree = !this.isPopModuleTree;
    },
    onSearchModuleNode() {
      this.$refs.moduleTree.filter(this.moduleName)
    },
    onClearModuleName() {
      this.moduleName = ""
      this.$refs.moduleTree.filter(this.moduleName)
      this.$refs.moduleTree.setCurrentKey(null);
    },
    onSearchPageNode() {
      this.$refs.pageTree.filter(this.pageName)
    },
    onClearPageName() {
      this.pageName = ""
      this.$refs.pageTree.filter(this.pageName)
    },
    filterModuleNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    filterPageNode(value, data) {
      if (!value) {
        return true
      }
      return data.label.indexOf(value) !== -1
    },
    popPageTree() {
      let _this = this;
      _this.isPopPageTree = !this.isPopPageTree;
      if(_this.isPopPageTree) {
        _this.$nextTick(function () {
          let curNode = _this.$refs.pageTree.getCurrentNode();
          if(curNode) {
            _this.expandAll(true)
            // let Seq = curNode.seq;
            // let lev1 = Math.trunc(Seq / 1000000) * 1000000
            // let lev2 = Math.trunc((Seq - lev1) / 10000) * 10000
            // let lev3 = Math.trunc((Seq - lev1 - lev2) / 100) * 100
            // let lev4 = Math.trunc((Seq - lev1 - lev2 - lev3))
            // lev3 = lev3 / 100
            // lev2 = lev2 / 10000
            // lev1 = lev1 / 1000000
            // console.log(Seq,lev2 + lev3 + lev4,curNode.cntidx,_this.allPages)
            _this.$refs.pageTree.$el.scrollTop = 26 * (curNode.cntidx)
          }
        })
      }
    },
    expandAll(bool) {
      let nodes = this.$refs.pageTree.store.nodesMap
      console.log(nodes)
      for (let i in nodes) {
        nodes[i].expanded = bool;
      }
    },
    unPopPageTree() {
      this.isPopPageTree = false;
    },
    fetchNavigationData() {
      let that = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/navigateData",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.navigationData = res.data;
          for(let i=0;i<5;i++){
            this.provincialCenterId = this.navigationData[i].moduleid;
            this.getRoleTreeRootNode(this.provincialCenterId)
          }
          this.getRoleTreeRootNode(this.provincialCenterId)
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    fetchAllPage() {
      let that = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/page",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.allPages = res.data
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    onSelectModuleNode(node) {
      let that = this;
      that.currentModule.moduleid = node.moduleid;
      that.currentModule.name = node.name;
      that.currentModule.seq = node.seq;
      that.currentModule.idx = node.idx;
      that.currentModule.pid = node.pid;
      that.currentModule.lev = node.lev;
      that.currentModule.isLeaf = node.isLeaf;
      that.currentModule.remark = node.remark;
      that.moduleName = node.name;
      if(that.currentModule.pages.length !=0){
        that.pageName = that.currentModule.pages[0].label;
        that.curNewPageName = that.currentModule.pages[0].label;
      }
      that.fetchModuleConfig();
    },
    async fetchModuleConfig() {
      let that = this;
      let moduleid = that.currentModule.moduleid;
      let url = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/template/" + moduleid;
      console.log(url);
      await axios({
        url: url,
        method: 'GET',
      }).then((res) => {
        // console.log(res);
        if (res.status === 200) {
          if (res.data.content != null) {
            that.currentModule.clearPages();
            for (let i = 0; i < res.data.content.pages.length; i++) {
              let page = res.data.content.pages[i];
              console.log(page);
              if (!Object.prototype.hasOwnProperty.call(page, "label")) {
                page.label = "页面" + (i + 1);
              }
              that.currentModule.addPage({
                label: page.label,
                pageid: page.pageid,
                route: page.route,
                type: page.type
              });
              this.onSwitchPage(0);
            }
          }
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    onClickAddNode() {
      console.log(this.currentModule)
      let that = this;
      let pid = that.currentModule.moduleid;
      let lev = that.currentModule.lev;
      ElMessageBox.prompt(
        '节点名称',
        '输入',
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(({ value }) => {
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            name: `${value}`,
            iconName: "el-icon-s-tools",
            pid: pid,
            lev: lev
          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            eventInsim.emit("moduleRefresh");
            that.fetchNavigationData();
            ElMessage({
              type: 'success',
              message: '节点添加成功',
            })
          }
          that.loading = false;
        }).catch((err) => {
          alert('Error');
          console.log(err)
          that.loading = false;
        })
      })
    },
    onClickMdfNode() {
      let that = this;
      let moduleid = that.currentModule.moduleid;
      ElMessageBox.prompt(
          '修改节点名称',
          '输入',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
      ).then(({ value }) => {
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/namecache",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            name: `${value}`,
            moduleid : moduleid,

          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            eventInsim.emit("moduleRefresh");
            that.fetchNavigationData();
            ElMessage({
              type: 'success',
              message: '修改成功',
            })
          }
          that.loading = false;
        }).catch((err) => {
          alert('Error');
          console.log(err)
          that.loading = false;
        })
      })
    },
    onClickDelNode() {
      let that = this
      let data = {
        moduleid: that.currentModule.moduleid,
        seq: that.currentModule.seq,
        lev: that.currentModule.lev
      }
      ElMessageBox.confirm(
          '确定删除？',
          '警告',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
          }
      ).then(() => {
        if(this.moduleName == "") {
          ElMessage({
            type: 'warning',
            message: '删除失败，未选择节点',
          })
        } else {
          this.moduleName = ""
          this.$refs.moduleTree.filter(this.moduleName)
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module",
            method: 'DELETE',
            headers: {
              "Content-Type": "application/json"
            },
            data: data
          }).then((res) => {
            if (res.status === 200) {
              console.log(res);
              eventInsim.emit("moduleRefresh");
              that.fetchNavigationData();
              ElMessage({
                type: 'success',
                message: '节点删除成功',
              })
            }
            that.loading = false;
          }).catch((err) => {
            alert('Error');
            console.log(err)
            that.loading = false;
          })
        }
      })

    },
    onChangePageName(){
      if(this.curNewPageName != "" && this.currentModule.pages[this.currentModule.pageIndex==undefined?0:this.currentModule.pageIndex] != undefined){
        this.currentModule.pages[this.currentModule.pageIndex==undefined?0:this.currentModule.pageIndex].label = this.curNewPageName;
      }
    },
    onSwitchPage(index) {
      let that = this;
      that.pageManager = true;
      that.currentModule.selectPage(index);
      that.pageName = that.currentModule.pages[index].label;
      that.curNewPageName = that.currentModule.pages[index].label;
      that.onSelectPage(that.currentModule.pages[index]);
      that.currentSelId = that.currentModule.pages[index].pageid;
      that.$nextTick(function (){
        that.$refs.pageTree.setCurrentKey(that.currentSelId);
      })
    },
    onClickAddPage() {
      let that = this;
      that.pageManager = true;
      that.currentModule.addPage(null);
    },
    onClickDelPage() {
      let that = this;
      that.currentModule.delPage(that.currentModule.pageIndex);
      this.pageName = ""
      this.$refs.pageTree.filter(this.pageName)
    },
    onSelectPage(page) {
      let that = this;
      console.log(page)
      console.log(that.currentModule)
      that.currentModule.pages[that.currentModule.pageIndex].label = page.label;
      that.currentModule.pages[that.currentModule.pageIndex].pageid = page.pageid;
      that.currentModule.pages[that.currentModule.pageIndex].route = page.route;
      that.currentModule.pages[that.currentModule.pageIndex].type = page.type;
      that.pageName = page.label
      that.curNewPageName = page.label
      this.isPopPageTree = false;
    },
    onClickOk() {
      let that  = this;
      if(that.sortcache !=null) {
        // 导航栏拖动排序后储存
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/sortcache",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: that.sortcache
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.fetchNavigationData();
            eventInsim.emit("moduleChange", that.currentModule);
            // that.$router.go(0);
          }
          that.loading = false;
          console.log(this.currentModule);
        }).catch((err) => {
          console.log(err)
          that.loading = false;
        })
      }
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module",
        method: 'PUT',
        headers: {
          "Content-Type": "application/json"
        },
        data: that.currentModule
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
          that.fetchNavigationData();
          eventInsim.emit("moduleChange", that.currentModule);
          ElMessage({
            type: 'success',
            message: '修改成功',
          })
          // that.$router.go(0);
        }
        that.loading = false;
        console.log(this.currentModule);
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })

console.log(that.sortcache)
    }
  }
}
</script>

<style lang="less">
.el-row {
  margin-bottom: 20px;
}

.module-navigatetree{
  position: relative;
  overflow: auto;
  width: 147%;
  height: 600px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
}

.module-pagetree {
  position: absolute;
  overflow: auto;
  width: 100%;
  height: auto;
  max-height : 300px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.custom-tree-btn {
  display: inline-block;
}
.remark {
  width: 550px;
}
</style>